import React, { Component } from "react";
import { Col, Row, Image } from "react-bootstrap";

// helpers
import { Date_Helper } from "./chartHelper";

// assets
import investIndiaLogo from "../../../assets/invest-india-logo_01.png";
import pmgLogoSvg from "../../../assets/PMG logo-80.svg";

export class PdfHeader extends Component {
  render() {
    return (
      <>
        {/* PDF Header Start */}
        <Col lg={12} className={`render-pdf header`}>
          <Row>
            <Col lg={3} className={"float-left"}>
              <Image src={investIndiaLogo} rounded />
            </Col>
            <Col lg={{ span: 2, offset: 7 }} className={"float-right"}>
              <Image src={pmgLogoSvg} rounded className={"float-right"} />
            </Col>
          </Row>
        </Col>

        <Col lg={12} className={`render-pdf header-title`}>
          <h4>PROJECT MONITORING GROUP (PMG) STATISTICS</h4>
          <span className="date-in-header">{Date_Helper()}</span>
        </Col>

        {/* PDF Header End */}
      </>
    );
  }
}
